<template>
  <div class="common" @click.stop="handleNav">
    <!-- 这个是通用的，有无图、三图、大图、单图 -->
    <div :class="important ? 'common_item1' : 'common_item'" v-if="[3, 2, 1, 0].findIndex((e) => e == article_info.articleType) != -1" >
      <div class="common_item_main">
        <div
          :href="article_info.url"
          class="common_item_main_title"
          :class="{ top_title: important }"
        >
          {{ article_info.title }}
        </div>
        <div class="common_item_main_img" v-if="article_info.articleType == 0">
          <van-image
            width="3.066667rem"
            height="2rem"
            fit="cover"
            :src="coverIMG(article_info.coverImagesList)"
            radius="5px"
          />
        </div>
      </div>
      <div
        class="common_item_three"
        v-if="article_info.articleType == 2"
        :class="{ less_than_three: article_info.coverImagesList.length < 3 }"
      >
        <div
          :href="article_info.url"
          v-for="item in article_info.coverImagesList.slice(0, 3)"
          class="common_item_three_item"
          :key="item.url"
        >
          <van-image
            width="100%"
            height="2rem"
            fit="cover"
            :src="item.url"
            radius="5px"
          />
        </div>
      </div>

      <div
        :href="article_info.url"
        class="common_item_bigimg"
        v-if="article_info.articleType == 1"
      >
        <van-image
          width="100%"
          height="5.5rem"
          fit="cover"
          :src="coverIMG(article_info.coverImagesList)"
          radius="5px"
        />
      </div>

      <div class="common_item_info" v-if="!important">
        <div class="common_item_info_item" v-if="article_info.top">
          <van-tag
            type="primary"
            size="medium"
            v-if="!important && active != 0"
            color="#f85959"
            class="common_item_info_tags"
            >置顶</van-tag
          >
          <van-tag
            type="primary"
            size="large"
            v-if="important"
            color="#f43f44"
            class="common_item_info_tags"
            >头条</van-tag
          >
        </div>
        <div class="common_item_info_item common_from">
          {{ article_info.from }}
        </div>
        <div class="common_item_info_item common_time">
          {{ handleDate(article_info.publishDate) }}
        </div>
      </div>
    </div>

    <div class="common_zhuanti" v-if="article_info.articleType == 9">
      <div class="common_zhuanti_main">
        <van-image
          width="100%"
          height="5rem"
          fit="cover"
          :src="coverIMG(article_info.coverImagesList)"
          radius="5px"
        />

        <div class="common_zhuanti_main_text">{{ article_info.title }}</div>

        <div class="common_zhuanti_main_info">
          <div class="common_item_info_item common_from">
            {{ article_info.from }}
          </div>
          <div class="common_item_info_item common_time">
            {{ handleDate(article_info.publishDate) }}
          </div>
        </div>

        <div class="common_zhuanti_tag">
          <van-tag type="primary" size="large" color="#f43f44">专题</van-tag>
        </div>
      </div>
      <div class="common_zhuanti_block"></div>
    </div>

    <div class="common_video" v-if="[8, 10].findIndex((e) => e == article_info.articleType) != -1" >
      <div class="common_video_block_t"></div>
      <div class="common_video_main">
        <van-image
          width="100%"
          height="5rem"
          fit="cover"
          :src="coverIMG(article_info.coverImagesList)"
          radius="5px"
        />
        <div class="common_video_tag">
          <van-tag
            type="primary"
            size="large"
            color="#f43f44"
            v-if="article_info.articleType == 8"
            >视频</van-tag
          >
          <van-tag
            type="primary"
            size="large"
            color="#f43f44"
            class="tag_zhibo"
            v-if="article_info.articleType == 10"
          >
            <img
              src="http://demo.htmleaf.com/1501/201501071637/svg-loaders/audio.svg"
              alt
              srcset
            />
            <span>直播</span>
          </van-tag>
        </div>

        <div class="common_video_text">{{ article_info.title }}</div>

        <div class="common_item_info_item common_time common_video_date">
          {{ handleDate(article_info.publishDate) }}
        </div>

        <div class="common_video_icon">
          <van-icon name="play-circle-o" color="#ffffff" />
        </div>
      </div>

      <div class="common_video_block"></div>
    </div>

    <!-- 广告条1001 -->
    <div class="common_guanggao" v-if="article_info.articleType == 1001">
      <div class="common_guanggao_img">
        <div>
          <van-image
            width="100%"
            height="2rem"
            fit="cover"
            :src="coverIMG(article_info.coverImagesList)"
            radius="5px"
          />
        </div>
      </div>

      <div class="common_guanggao_block"></div>
    </div>

    <!-- 通用轮播图1000 -->
    <div class="common_swiper" v-if="article_info.articleType == 1000">
      <SwiperItem :article_info="article_info"></SwiperItem>
    </div>
  </div>
</template>

<script>
import { inject, toRefs } from "vue";

import SwiperItem from "./SwiperItem";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/zh-cn";

import { coverIMG } from "../utils/helper";

dayjs.locale("zh-cn");

dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);

export default {
  props: {
    article_info: Object,
    important: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SwiperItem,
  },
  setup(props) {
    // 获取活动的active
    const active = inject("active", 0);

    const { article_info } = toRefs(props);

    // 处理日期的方法
    const handleDate = (d) => {
      const after = dayjs(+d);
      const now = dayjs();
      const diff = now.diff(after, "day");
      if (diff > 0) {
        return after.format("YYYY-MM-DD");
      } else {
        return after.fromNow();
      }
    };

    const handleNav = () => {
      window.location = article_info.value.url;
    };

    return {
      handleDate,
      coverIMG,
      active,
      handleNav,
    };
  },
};
</script>

<style scoped>
.common_item {
  width: 95%;
  margin: 0 auto;
  border-bottom: 1px solid #f3f4f5;
  padding-top: 10px;
  padding-bottom: 30px;
  min-height: 80px;
  box-sizing: border-box;
  position: relative;
}

.common_item1 {
  width: 95%;
  margin: 0 auto;
  /* border-bottom: 1px solid #f3f4f5; */
  padding-top: 6px;
   padding-bottom:6px;
  box-sizing: border-box;
  position: relative;
  line-height: 32px;
}


.common_item_main {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.common_item_main_title {
  font-size: 18px;
  line-height: 32px;
  color: #222;
}

.common_item1 .common_item_main_title{color: #333!important; font-weight: normal!important; }
.common_item1:before{content: ""; width:8px; height:8px; background:#444; display: block; float: left; margin: 12px 7px 0 0; border-radius: 50%;}

.common_item_main_img {
  margin-left: 10px;
  flex: none;
}

.common_item_info {
  font-size: 14px;
  position: absolute;
  bottom: 7px;
  display: flex;
  align-items: center;
}

.common_from,
.common_time {
  color: #999;
  font-size: 12px;
  margin-top: 3px;
  margin-right: 10px;
}

.common_item_three {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  margin-top: 5px;
}

.common_item_three_item {
  flex: none;
  width: 32%;
  max-width: 224px;
  display: block;
}

.less_than_three.common_item_three {
  justify-content: flex-start;
}

.less_than_three.common_item_three .common_item_three_item:nth-child(n + 2) {
  margin-left: 0.266667rem;
}

.top_title {
  font-weight: bold;
  color: #ff0000;
}

.common_item_bigimg {
  margin-top: 5px;
  display: block;
}

.common_item_info_tags {
  margin-right: 10px;
}

.common_zhuanti {
  margin-top: 0.533333rem;
}

.common_zhuanti_main {
  width: 90%;
  margin: 0 auto;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  position: relative;
  display: block;
}

.common_zhuanti_main_info {
  display: flex;
  align-items: center;
  width: 95%;
  margin: 0 auto;
  margin-top: 5px;
  margin-bottom: 10px;
}

.common_zhuanti_main_text {
  font-size: 18px;
  width: 95%;
  margin: 0 auto;
  margin-top: 10px;
  line-height: 28px;
  color: #222;
}

.common_video_date {
  width: 95%;
  margin: 0 auto;
  padding-bottom: 0.266667rem;
}

.common_zhuanti_block {
  width: 100%;
  height: 0.2rem;
  background-color: #f3f4f5;
  margin-top: 20px;
}

.common_zhuanti_tag {
  position: absolute;
  top: 0.266667rem;
  left: 0.266667rem;
}

.common_video {
}

.common_video_main {
  width: 95%;
  margin: 0 auto;
  position: relative;
  display: block;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 5px;
}

.common_video_tag {
  position: absolute;
  top: 0.266667rem;
  left: 0.266667rem;
}

.common_video_text {
  width: 95%;
  margin: 0 auto;
  font-size: 16px;
  line-height: 24px;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

.common_video_block {
  width: 100%;
  height: 0.2rem;
  background-color: #f3f4f5;
  margin-top: 0.533333rem;
}

.common_video_block_t {
  width: 100%;
  height: 0.2rem;
  background-color: #f3f4f5;
  margin-bottom: 0.333333rem;
}

.common_video_icon {
  width: 1.5rem;
  height: 1.5rem;
  position: absolute;
  top: 33%;
  left: 50%;
  font-size: 1.5rem;
  transform: translate(-50%, -50%);
}

.tag_zhibo {
  display: flex;
}

.tag_zhibo img {
  width: 14px;
}

.tag_zhibo span {
  padding-left: 5px;
}

.common_guanggao {
  margin-top: 0.4rem;
}

.common_guanggao_img {
  width: 90%;
  margin: 0 auto;
}

.common_guanggao_block {
  width: 100%;
  height: 0.2rem;
  background-color: #f3f4f5;
  margin-top: 0.333333rem;
}
</style>